import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import useAutoRefresh from "@/hooks/useAutoRefresh";
import { Swords } from "lucide-react";

export default function RivalryBoard() {
  const [rivalries, setRivalries] = useState([]);
  const load = useCallback(async () => {
    try { const { data } = await api.get("/community/rivalries"); setRivalries(data); } catch { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);
  useAutoRefresh(load);

  if (rivalries.length === 0) return null;
  return (
    <div data-testid="rivalry-board"
      className="border border-[#F472B6]/50 bg-gradient-to-br from-[#F472B6]/10 via-pb-surface/60 to-pb-surface/40 p-5 shadow-[0_0_24px_rgba(244,114,182,0.08)]">
      <div className="flex items-center gap-2 mb-1">
        <Swords className="w-4 h-4 text-[#F472B6]" />
        <h3 className="font-display font-bold text-lg uppercase text-[#F472B6]">Rivalry Leaderboard</h3>
      </div>
      <p className="text-[11px] text-zinc-500 mb-4">The Bullpen's most active rec-game rivalries — log yours on the LDA Training page.</p>
      <div className="space-y-2">
        {rivalries.map((r, i) => (
          <div key={`${r.a}-${r.b}`} data-testid={`rivalry-${i}`}
            className="relative flex items-center gap-2.5 border border-pb-border/60 bg-pb-base/40 px-3 py-2.5 transition-all hover:border-[#F472B6]/50">
            <span className="pointer-events-none absolute inset-y-0 left-0 w-[2px] bg-gradient-to-b from-[#F472B6] to-[#22D3EE] opacity-50" />
            <span className="font-mono text-[10px] text-zinc-600 w-4 shrink-0">{String(i + 1).padStart(2, "0")}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold leading-tight truncate">
                {r.a} <span className="text-[#F472B6] font-display font-black text-[10px] uppercase mx-1">vs</span> {r.b}
              </div>
              <div className="font-mono text-[11px] text-zinc-500 mt-0.5">
                <span className="text-green-400">{r.a_wins}</span>
                <span className="text-zinc-600"> – </span>
                <span className="text-pb-cyan">{r.b_wins}</span>
                <span className="text-zinc-600"> · {r.games} game{r.games === 1 ? "" : "s"}</span>
              </div>
            </div>
            <div className="w-14 shrink-0 hidden sm:block">
              <div className="h-1.5 bg-pb-elevated overflow-hidden rounded-full">
                <div className="h-full rounded-full" style={{ width: `${Math.round((r.a_wins / Math.max(1, r.a_wins + r.b_wins)) * 100)}%`, background: "linear-gradient(90deg,#F472B6,#22D3EE)" }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
